<template>
  <div class="fgtpwd_1">
    <div class="heatab">找回密码</div>

    <el-form :model="form" :rules="rules" ref="form" class="form">
      <el-form-item prop="pwd1">
        <el-input placeholder="请输入新密码" v-model="form.pwd1" />
      </el-form-item>

      <el-form-item prop="pwd2">
        <el-input placeholder="确认密码" v-model="form.pwd2" />
      </el-form-item>

      <div class="regbtn" @click="submit">下一步</div>

      <div class="yyzh">已有帐号，前往<span>登录</span></div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    let that = this
    var validatorpwd = function (rule, value, callback) {
      let passwordreg = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/
      if (value === "") {
        callback(new Error("密码不能为空"));
      }
       else if (!passwordreg.test(value)) {
            callback(new Error('大写字母、小写字母、数字、特殊符号中至少包含两种!'))
          }
      else {
        callback();
      }
    };
    
    var validatorpwd2 = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("密码不能为空"));
      }
      else if(!(that.form.pwd1 === that.form.pwd2)){
        callback(new Error("两次密码输入不一致"));

      }  else {
        callback();
      }
    };
    return {
      yzmtext: "发送验证码",
      yzmtime: 60,
      disabled: true, //是否可以获取验证码
      form: {
        pwd1: "",
        pwd2: "",
      },
      rules: {
        pwd1: [{ validator: validatorpwd, trigger: "blur" }],
        pwd2: [{ validator: validatorpwd2, trigger: "blur" }],
      },
      showuseragree: false,
    };
  },
  beforeMount() {
    this.$parent._data.currentactep = 2;
  },
  methods: {
    changetype(index) {
      this.type = index;
      this.$refs.form.resetFields();
    },
    // 获取验验证码
    getyzm() {
      if (this.yzmtime > 1) {
        this.disabled = false;
        this.yzmtime--;
        this.yzmtext = this.yzmtime + "秒";
        setTimeout(this.getyzm, 1000);
      } else {
        this.yzmtime = 60;
        this.yzmtext = "发送验证码";
        this.disabled = true;
      }
    },
    // 提交
    submit() {
      console.log(this.form);

      console.log(this.$refs.sjhitem);
      this.$router.push({
        path: "/log/fgtpwd/fgtpwd_3",
      });
    },
    // 手机号失去焦点
    sjhblur(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.fgtpwd_1 {
  margin-left: auto;
  margin-right: auto;
  width: 900px;
  background: #ffffff;
  box-shadow: 1px 1px 9px 0px rgba(0, 0, 0, 0.11);
  border-radius: 3px;
  .heatab {
    height: 76px;
    line-height: 76px;
    border-radius: 3px 3px 0px 0px;
    text-align: center;
    font-size: 24px;
    background: #0057ff;
    color: #ffffff;
  }
  .form {
    margin-left: auto;
    margin-right: auto;
    padding-top: 50px;
    padding-bottom: 90px;
    width: 340px;
    .formeliten {
      width: 100%;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      background: #ffffff;
      position: relative;
      .yzm {
        width: 214px;
        height: 40px;
        border-radius: 3px;
      }
      .getyzm {
        width: 110px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #0057ff;
        color: #ffffff;
        border-radius: 3px;
        font-size: 14px;
        &.djs {
          background: #4b74c5;
        }
      }
    }

    .regbtn {
      cursor: pointer;
      width: 336px;
      margin: 30px auto 0;
      height: 44px;
      text-align: center;
      line-height: 44px;
      border-radius: 3px;
      font-size: 18px;
      background: #f4f4f4;
      color: #999999;
      &:hover {
        background: #0057ff;
        color: #ffffff;
      }
    }

    .yyzh {
      margin-top: 20px;
      font-size: 14px;
      color: #333333;
      letter-spacing: 2px;
      span {
        cursor: pointer;
        color: #0057ff;
      }
    }
  }
}
</style>